import React from 'react';
import { useGlobalStyles } from 'GlobalStyles';
import strings from 'strings';
import { FPCard, FPCardContent } from 'UI/components/atoms/FPCard';
import FileManager from 'UI/components/organisms/FileManager';
import { DefaultNewCandidateFileCategories } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { CandidateEntity } from 'UI/constants/entityTypes';

const DELETE_API_VERSION = 1;

export const AttachmentsSection = ({ initialFiles, onAttachmentsChanged }) => {
  const globalClasses = useGlobalStyles();

  return (
    <FPCard className={globalClasses.newItemsSection}>
      <FPCardContent
        variant="relaxed"
        headerProps={{
          title: strings.fileManager.newProfile.sectionTitle,
          subheader: strings.formatString(strings.fileManager.newProfile.sectionSubtitle, {
            categorySuggested: 'resume'
          }),
          variant: 'section'
        }}
      >
        <FileManager
          apiVersionForDeleting={DELETE_API_VERSION}
          defaultCategories={DefaultNewCandidateFileCategories}
          filesEndpoint={Endpoints.Files}
          initialFiles={initialFiles}
          isNewEntity
          module={CandidateEntity.module}
          onAttachmentsChanged={onAttachmentsChanged}
          showItemDate
          showItemMenu
          viewItemOnClick
        />
      </FPCardContent>
    </FPCard>
  );
};
